/** Base del API sin barra final (solo host + puerto del backend). Quita /api al final si se pegó por error. */
export function getRawBackendUrl() {
  let s = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
  if (/\/api\/?$/i.test(s)) {
    s = s.replace(/\/api\/?$/i, "").replace(/\/+$/, "");
  }
  return s;
}

/** En `npm start`, por defecto las peticiones van a `/api` y setupProxy.js las reenvía al backend (misma origen → menos errores de red/CORS). */
export function isDevProxyEnabled() {
  return (
    process.env.NODE_ENV === "development" &&
    String(process.env.REACT_APP_DEV_PROXY || "1").trim() !== "0"
  );
}

/** Destino del proxy en desarrollo (coincide con setupProxy.js). */
export function getDevProxyTarget() {
  return getRawBackendUrl() || "http://127.0.0.1:8000";
}

/** baseURL de axios: en desarrollo con proxy suele ser `/api`; en build, `${REACT_APP_BACKEND_URL}/api`. */
export function getApiBase() {
  if (isDevProxyEnabled()) return "/api";
  const raw = getRawBackendUrl();
  return raw ? `${raw}/api` : "";
}

/** Texto para mensajes de error de conexión. */
export function getConnectionHint() {
  if (isDevProxyEnabled()) {
    return `proxy de desarrollo /api → ${getDevProxyTarget()}`;
  }
  const base = getApiBase();
  return base || "sin REACT_APP_BACKEND_URL (defina la URL del API y vuelva a compilar)";
}
